import { Icon } from '../Icon/Icon';
import { twJoin } from 'tailwind-merge';

type MapMarkerIconProps = {
    isActive?: boolean;
    isClickable?: boolean;
};

export const StoreMapMarkerIcon: FC<MapMarkerIconProps> = ({ isActive, isClickable, className }) => {
    return (
        <Icon
            iconType="icon"
            icon="Marker"
            className={twJoin(
                'relative -top-3 h-8 w-8 transition hover:brightness-90 active:brightness-75',
                isActive && 'scale-125 text-primary',
                isClickable ? 'cursor-pointer' : 'cursor-default',
                className,
            )}
        />
    );
};
